(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.LnaRoomLayout = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var GAP = 2.5;   // % de la largeur entre deux objets
  var ARC = 3;     // % de la hauteur : les objets des côtés descendent un peu
  var LAMP_GAP = 1.2; // les veilleuses sont groupées, plus serrées que le reste
  // Motifs des compositions LNA, en cellules (1 = largeur ou hauteur d'un objet + écart) :
  // 2 côte à côte, 3 en arc, 4 en losange, 5 et 6 en arc au-dessus d'une petite rangée.
  var PATTERNS = {
    1: [[0, 0]],
    2: [[-0.5, 0], [0.5, 0]],
    3: [[-1, 0.3], [0, 0], [1, 0.3]],
    4: [[0, -0.55], [-1, 0], [1, 0], [0, 0.55]],
    5: [[-1, 0.3], [0, 0], [1, 0.3], [-0.5, 1.3], [0.5, 1.3]],
    6: [[-1.5, 0.3], [-0.5, 0], [0.5, 0], [1.5, 0.3], [-0.5, 1.3], [0.5, 1.3]]
  };
  var BANDS = {
    lamps: { minScale: 0.55, maxRows: 3, arc: true, patterns: true }
  };

  function size(item, room, scale) {
    var w = item.widthCm * room.cmToPct * scale;
    return { w: w, h: w / (item.ar || 1) / room.aspect };
  }

  function splitRows(sizes, width, maxRows) {
    var rows = [[]], used = 0;
    sizes.forEach(function (s, i) {
      var row = rows[rows.length - 1];
      var need = row.length ? used + GAP + s.w : s.w;
      if (need > width && row.length && rows.length < maxRows) { rows.push([i]); used = s.w; }
      else { row.push(i); used = need; }
    });
    return rows;
  }

  function measure(rows, sizes, arc) {
    var height = 0, width = 0;
    rows.forEach(function (row, r) {
      var rw = 0, rh = 0;
      row.forEach(function (i, k) { rw += sizes[i].w + (k ? GAP : 0); rh = Math.max(rh, sizes[i].h); });
      width = Math.max(width, rw);
      height += rh + (r ? GAP / 2 : 0) + (arc && row.length >= 3 ? ARC : 0);
    });
    return { width: width, height: height };
  }

  // Cherche la plus grande échelle qui tient : à taille égale, une ligne de plus plutôt que des objets plus petits.
  function fit(items, zone, room, band) {
    for (var scale = 1; scale >= band.minScale - 1e-9; scale -= 0.05) {
      for (var rowsAllowed = 1; rowsAllowed <= band.maxRows; rowsAllowed++) {
        var sizes = items.map(function (it) { return size(it, room, scale); });
        var rows = splitRows(sizes, zone.w, rowsAllowed);
        var m = measure(rows, sizes, band.arc);
        if (m.width <= zone.w + 1e-9 && m.height <= zone.h + 1e-9) return { sizes: sizes, rows: rows };
      }
    }
    // Dernier recours : on réduit sans plancher pour ne jamais sortir de la zone.
    for (var s = band.minScale; s > 0.05; s -= 0.05) {
      var sz = items.map(function (it) { return size(it, room, s); });
      var rw = splitRows(sz, zone.w, band.maxRows);
      var mm = measure(rw, sz, band.arc);
      if (mm.width <= zone.w + 1e-9 && mm.height <= zone.h + 1e-9) return { sizes: sz, rows: rw };
    }
    return { sizes: items.map(function (it) { return size(it, room, 0.05); }), rows: [items.map(function (_, i) { return i; })] };
  }

  // Les veilleuses prennent les places centrales, étagères et miroirs (decor) les places extérieures.
  function centralFirst(pattern, lamps, decor) {
    if (!decor.length) return lamps;  // que des veilleuses : l'ordre d'ajout fait le motif
    var slots = pattern.map(function (p, i) { return i; })
      .sort(function (a, b) { return Math.abs(pattern[a][0]) - Math.abs(pattern[b][0]) || pattern[a][1] - pattern[b][1]; });
    var ranked = lamps.concat(decor), arranged = [];
    slots.forEach(function (slot, k) { arranged[slot] = ranked[k]; });
    return arranged;
  }

  function endsOut(lamps, decor) {
    var half = Math.ceil(decor.length / 2);
    return decor.slice(0, half).concat(lamps, decor.slice(half));
  }

  function placePattern(items, zone, room, band, out) {
    var pattern = PATTERNS[items.length];
    for (var scale = 1; scale >= band.minScale - 1e-9; scale -= 0.05) {
      var sizes = items.map(function (it) { return size(it, room, scale); });
      var cellW = Math.max.apply(null, sizes.map(function (s) { return s.w; })) + LAMP_GAP;
      var cellH = Math.max.apply(null, sizes.map(function (s) { return s.h; })) + LAMP_GAP / room.aspect;
      var boxes = sizes.map(function (s, i) {
        return { x: pattern[i][0] * cellW - s.w / 2, y: pattern[i][1] * cellH - s.h / 2, w: s.w, h: s.h };
      });
      var left = Math.min.apply(null, boxes.map(function (b) { return b.x; }));
      var right = Math.max.apply(null, boxes.map(function (b) { return b.x + b.w; }));
      var top = Math.min.apply(null, boxes.map(function (b) { return b.y; }));
      var bottom = Math.max.apply(null, boxes.map(function (b) { return b.y + b.h; }));
      if (right - left > zone.w + 1e-9 || bottom - top > zone.h + 1e-9) continue;
      var dx = zone.x + (zone.w - (right - left)) / 2 - left;
      var dy = zone.y + (zone.h - (bottom - top)) / 2 - top;
      boxes.forEach(function (b, i) { out[items[i].uid] = { x: b.x + dx, y: b.y + dy, w: b.w, h: b.h }; });
      return true;
    }
    return false;
  }

  function placeBand(items, zone, room, band, out, decor) {
    decor = decor || [];
    var all = items.concat(decor);
    if (!all.length) return;
    if (band.patterns && PATTERNS[all.length] &&
        placePattern(centralFirst(PATTERNS[all.length], items, decor), zone, room, band, out)) return;
    items = endsOut(items, decor);
    var f = fit(items, zone, room, band);
    var y = zone.y + (zone.h - measure(f.rows, f.sizes, band.arc).height) / 2;
    f.rows.forEach(function (row) {
      var rowW = 0, rowH = 0;
      row.forEach(function (i, k) { rowW += f.sizes[i].w + (k ? GAP : 0); rowH = Math.max(rowH, f.sizes[i].h); });
      var x = zone.x + (zone.w - rowW) / 2;
      var mid = (row.length - 1) / 2;
      var arcOn = band.arc && row.length >= 3;
      row.forEach(function (i) {
        var s = f.sizes[i];
        var dy = arcOn ? ARC * Math.pow((row.indexOf(i) - mid) / mid, 2) : 0;
        out[items[i].uid] = { x: x, y: y + dy + (rowH - s.h) / 2, w: s.w, h: s.h };
        x += s.w + GAP;
      });
      y += rowH + (arcOn ? ARC : 0) + GAP / 2;
    });
  }

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  function layout(items, room) {
    var out = {}, lamps = [], decor = [], manual = [];
    items.forEach(function (it) {
      if (it.category === 'sticker') return;
      if (it.manual) { manual.push(it); return; }
      // une lettre est une veilleuse : même groupe, même motif, dans l'ordre d'ajout (Yann, 04/10)
      if (it.category === 'veilleuse' || it.category === 'alphabet') lamps.push(it);
      else decor.push(it);  // étagères et miroirs : dans le groupe, aux places extérieures
    });
    placeBand(lamps, room.zones.lamps, room, BANDS.lamps, out, decor);
    manual.forEach(function (it) {
      // un objet déplacé garde la largeur qu'il avait dans son groupe (manual.w), sinon sa taille réelle
      var s = it.manual.w ? { w: it.manual.w, h: it.manual.w / (it.ar || 1) / room.aspect } : size(it, room, 1);
      out[it.uid] = { x: clamp(it.manual.x - s.w / 2, 0, 100 - s.w), y: clamp(it.manual.y - s.h / 2, 0, 100 - s.h), w: s.w, h: s.h };
    });
    return out;
  }

  function seedOf(str) {
    var h = 2166136261;
    for (var i = 0; i < String(str).length; i++) { h ^= String(str).charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }

  function rng(a) {
    return function () {
      a |= 0; a = a + 0x6D2B79F5 | 0;
      var t = Math.imul(a ^ a >>> 15, 1 | a);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }

  function inside(px, py, r) { return px > r.x && px < r.x + r.w && py > r.y && py < r.y + r.h; }

  function scatter(seed, count, wall, avoid) {
    var rand = rng(seed), pts = [];
    var cols = Math.ceil(Math.sqrt(count * wall.w / wall.h)), rows = Math.ceil(count / cols);
    var cw = wall.w / cols, ch = wall.h / rows;
    for (var r = 0; r < rows; r++) {
      for (var c = 0; c < cols; c++) {
        var x = wall.x + (c + 0.5 + (rand() - 0.5) * 0.7) * cw;
        var y = wall.y + (r + 0.5 + (rand() - 0.5) * 0.7) * ch;
        var s = 0.6 + rand() * 0.4, rot = (rand() - 0.5) * 30;
        if (avoid.some(function (a) { return inside(x, y, a); })) continue;
        pts.push({ x: x, y: y, s: s, r: rot });
      }
    }
    return pts;
  }

  // Les stickers entourent le groupe de veilleuses, comme sur les compositions ; sans veilleuse, haut du mur.
  function stickerRegion(rects, wall) {
    var list = Object.keys(rects).map(function (k) { return rects[k]; });
    if (!list.length) return { x: wall.x, y: wall.y, w: wall.w, h: wall.h * 0.6 };
    var left = Math.min.apply(null, list.map(function (r) { return r.x; }));
    var right = Math.max.apply(null, list.map(function (r) { return r.x + r.w; }));
    var top = Math.min.apply(null, list.map(function (r) { return r.y; }));
    var bottom = Math.max.apply(null, list.map(function (r) { return r.y + r.h; }));
    var EDGE = 2; // jamais collé au bord du mur
    var mx = Math.max(6, (right - left) * 0.3), my = Math.max(6, (bottom - top) * 0.3);
    var x = Math.max(wall.x + EDGE, left - mx), y = Math.max(wall.y + EDGE, top - my);
    return { x: x, y: y, w: Math.min(wall.x + wall.w - EDGE, right + mx) - x, h: Math.min(wall.y + wall.h - EDGE, bottom + my) - y };
  }

  // « 3 petits nuages » en bois : 3 par pack, autour du groupe de veilleuses — centre au-dessus, gauche, droite,
  // puis une couronne plus large pour les packs suivants (une couleur par pack).
  function trio(rects, wall, size, count) {
    count = count || 3;
    var list = Object.keys(rects).map(function (k) { return rects[k]; });
    var w = size.w, h = size.h, EDGE = 2, gX = 2.5, gY = 2;
    function box(cx, cy) {
      return { x: clamp(cx - w / 2, wall.x + EDGE, wall.x + wall.w - EDGE - w),
        y: clamp(cy - h / 2, wall.y + EDGE, wall.y + wall.h - EDGE - h), w: w, h: h };
    }
    var L, R, top, bottom;
    if (list.length) {
      L = Math.min.apply(null, list.map(function (r) { return r.x; }));
      R = Math.max.apply(null, list.map(function (r) { return r.x + r.w; }));
      top = Math.min.apply(null, list.map(function (r) { return r.y; }));
      bottom = Math.max.apply(null, list.map(function (r) { return r.y + r.h; }));
    } else {
      L = R = wall.x + wall.w / 2; top = wall.y + wall.h * 0.25; bottom = top + h;
      L -= wall.w * 0.15; R += wall.w * 0.15;
    }
    var c = (L + R) / 2, cy = top + (bottom - top) * 0.35, ty = top - gY - h / 2;
    var spots = [[c, ty], [L - gX - w / 2, cy], [R + gX + w / 2, cy],
      [L - 2 * gX - 1.5 * w, cy + 0.6 * h], [R + 2 * gX + 1.5 * w, cy + 0.6 * h],
      [c - w - gX, ty - 0.4 * h], [c + w + gX, ty - 0.4 * h],
      [L - gX - w / 2, cy + h + gY], [R + gX + w / 2, cy + h + gY]];
    return spots.slice(0, Math.min(count, spots.length)).map(function (p) { return box(p[0], p[1]); });
  }

  return { layout: layout, scatter: scatter, seedOf: seedOf, stickerRegion: stickerRegion, trio: trio };
});
